<template>
  <div
    id="Regionales"
    v-if="$store.state.global_privilegio_admin_registro_regional.ver"
  >
    <AdminMenu />
    <div class="row justify-content-md-center align-items-center">
      <div class="col-md-10">
        <div class="row container_admin">
          <!-- LISTA DE REGIONALES -->
          <div class="col-6 text-left mt-2">
            <b class="titulo">Regionales</b>
          </div>
          <div class="col-6 d-flex justify-content-end mt-2">
            <button
              v-show="$store.state.global_privilegio_admin_registro_regional.crear"
              type="button"
              class="btn boton_guardar1"
              data-toggle="modal"
              data-target="#agregarregional"
              style="margin-right: 3%"
            >
              <img
                src="img/iconos/regionales.png"
                alt="logo-color"
                class="icono mr-2"
              />Nueva Regional
            </button>
          </div>
          <div class="col-12 table mt-3">
            <v-client-table
              class="col-md-12 mt-3"
              :columns="columns"
              :data="informacion_region"
              :options="options"
            >
              <div slot="opciones" slot-scope="props">
                <center>
                  <button
                    class="btn dropdown-toggle boton_12"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <ul class="dropdown-menu b-dropdown-opt" role="menu">
                      <center>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="consultar_regional(props.row.id)"
                            v-show="
                              $store.state.global_privilegio_admin_registro_regional
                                .editar
                            "
                            >&nbsp;<b>Editar</b>
                          </a>
                        </li>
                      </center>
                      <center>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="eliminar_regional(props.row.id)"
                            v-show="
                              $store.state.global_privilegio_admin_registro_regional
                                .eliminar
                            "
                            >&nbsp;<b>Eliminar</b></a
                          >
                        </li>
                      </center>
                    </ul>
                  </button>
                </center>
              </div>
            </v-client-table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR REGIONAL -->
    <div
      class="modal fade"
      id="agregarregional"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"><b>Nueva Regional</b></label> <br />
            </div>
            <div class="box-body row">
              <div class="col-md-1"></div>
              <div class="col-md-4">
                <label class="color">Crear Regional:</label>
                <input
                  type="text"
                  v-model="nueva_region"
                  class="form-control boton_texto Mayus"
                  placeholder="Nueva Regional"
                /><br />

                <label class="color">Regional Existente:</label>
                <select
                  class="form-control boton_texto"
                  v-model="regional_existente"
                >
                  <option value="" selected disabled>Regionales</option>
                  <option
                    v-for="(item8, index) of mostrar_regionales"
                    :key="index"
                  >
                    {{ item8.regionales }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="color_letra">Departartamento:</label>
                <select
                  class="form-control boton_texto"
                  v-model="departamento"
                  @change="municipios_colombia"
                >
                  <option value="">Departamentos</option>
                  <option
                    v-for="(item_depar, index) of array_departamento"
                    :value="item_depar.departamento"
                    :key="index"
                  >
                    {{ item_depar.departamento }}
                  </option>
                </select>
              </div>
              <div v-if="departamento == ''">
                <label class="color_letra">Municipios:</label>
              </div>
              <div class="row" v-if="departamento != ''">
                <div class="col-sm-12">
                  <label class="color_letra mt-5 ml-5">Municipios:</label>
                  <input type="checkbox" v-model="selectAll" /> Seleccionar
                  Todos
                </div>
                <div
                  class="col-md-2 ml-5"
                  v-for="(i, index) in municipio_general"
                  :key="index"
                >
                  <input type="checkbox" v-model="municipio" :value="i" />
                  {{ i }}
                </div>
              </div>
              <div class="col-md-12">
                <br />
                <center>
                  <button
                    class="btn boton_guardar mt-5 mr-3"
                    @click="
                      agregar_regional(
                        nueva_region,
                        regional_existente,
                        departamento,
                        municipio
                      )
                    "
                  >
                    Guardar
                  </button>
                  <button
                    class="btn boton_guardar mt-5"
                    @click="
                      agregar_regional1(
                        nueva_region,
                        regional_existente,
                        departamento,
                        municipio
                      )
                    "
                  >
                    Siguiente Departamento
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EDITAR REGIONAL -->
    <div
      class="modal fade"
      id="editarregional"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content container_admin">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="col-md-10">
              <label class="dato ml-3"><b>Editar Regional</b></label> <br />
            </div>
            <div class="box-body row">
              <div class="col-md-2"></div>
              <div class="col-md-3">
                <label class="color_letra">Regional:</label>
                <input
                  type="text"
                  v-model="con_regional"
                  class="form-control boton_texto Mayus"
                />
              </div>
              <div class="col-md-3">
                <label class="color_letra">Departartamento:</label>
                <select
                  class="form-control boton_texto"
                  v-model="con_departamento"
                  @change="municipios1"
                >
                  <option value="">Departamentos</option>
                  <option
                    v-for="(item_depar, index) of array_departamento"
                    :value="item_depar.departamento"
                    :key="index"
                  >
                    {{ item_depar.departamento }}
                  </option>
                </select>
              </div>
              <div class="col-sm-12">
                <label class="color_letra mt-5 ml-5">Municipios:</label>
                <input
                  type="checkbox"
                  id="checkTodos"
                  @click="seleccionarTodo"
                />Marcar/Desmarcar Todos
              </div>
              <div
                class="col-md-2 ml-5"
                v-for="(i, index) of municipio_general1"
                :key="index"
              >
                <input type="checkbox" v-model="con_municipios" :value="i" />{{
                  i
                }}
              </div>
              <div class="col-md-12">
                <br />
                <center>
                  <button
                    class="btn boton_guardar mt-5 mr-3"
                    @click="editar_regional()"
                  >
                    Guardar
                  </button>
                  <button
                    class="btn boton_guardar mt-5"
                    @click="vaciar_variables()"
                  >
                    Cancelar
                  </button>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="alert alert-warning" role="alert" v-else>
    No tiene permiso para ver el Módulo
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "../../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "Regionales",
  components: {
    AdminMenu,
  },
  data() {
    return {
      guardar_todos: "",
      selected: [],

      departamento_select: "",
      array_departamento: [],
      municipio_general: [],
      municipio_general1: [],
      mostrar_regionales: [],

      // VARIABLES REGISTRO DE REGIONALES
      departamento: "",
      nueva_region: "",
      regional_existente: "",
      municipio: [],
      session_email: "",

      // VARIABLE CONSULTA DE REGIONALES
      con_key: "",
      con_regional: "",
      con_departamento: "",
      con_municipios: [],
      con_vacio: [],

      regionales: null,

      informacion_region: [],
      columns: ["regional", "departamento", "ciudad", "opciones"],
      options: {
        headings: {
          regional: "Regional",
          departamento: "Departamento",
          ciudad: "Ciudad",
          opciones: "Opciones",
        },
        sortable: ["regional", "departamento", "ciudad", "opciones"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
      },
      vairable_departamento: "",
    };
  },
  created() {
    if (
      this.$store.state.global_privilegio_admin_registro_regional.ver == true
    ) {
      this.consultar_regionales_existentes();
      this.tabla_regional();
      this.departamentos();
    }
  },
  methods: {
    // TABLA DE USUARIO
    tabla_regional() {
      if (this.informacion_region.length > 0) {
      } else {
        this.informacion_region = [];
        db.collection("nuevo_regional")
          .orderBy("r_fecha_registro", "asc")
          .onSnapshot((snapshot) => {
            let changes = snapshot.docChanges();
            changes.forEach((change) => {
              if (change.type === "added") {
                this.informacion_region.unshift({
                  id: change.doc.id,
                  regional: change.doc.data().r_nueva_region,
                  departamento: change.doc.data().r_departamento,
                  ciudad: `${change.doc.data().r_municipios}`,
                });
              }
              if (change.type === "modified") {
                for (
                  let index = 0;
                  index < this.informacion_region.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_region[index].id) {
                    this.informacion_region.splice(index, 1);
                  }
                }
                this.informacion_region.unshift({
                  id: change.doc.id,
                  regional: change.doc.data().r_nueva_region,
                  departamento: change.doc.data().r_departamento,
                  ciudad: change.doc.data().r_municipios,
                });
              }
              if (change.type === "removed") {
                for (
                  let index = 0;
                  index < this.informacion_region.length;
                  index++
                ) {
                  if (change.doc.id == this.informacion_region[index].id) {
                    this.informacion_region.splice(index, 1);
                  }
                }
              } else {
              }
              // DEVOLVER SOLO DATOS ÚNICOS, NO REPETIDOS
              let set = new Set(this.informacion_region.map(JSON.stringify));
              this.informacion_region = Array.from(set).map(JSON.parse);
            });
          });
      }
    },

    consultar_regionales_existentes() {
      let regional_existente = "";
      let docRef = db
        .collection("nuevo_regional")
        .orderBy("r_nueva_region", "asc");
      docRef.onSnapshot((querySnapshot) => {
        this.mostrar_regionales = [];
        querySnapshot.forEach((doc) => {
          if (`${doc.data().r_nueva_region}` != regional_existente) {
            this.mostrar_regionales.push({
              key: doc.id,
              regionales: `${doc.data().r_nueva_region}`,
            });
            regional_existente = `${doc.data().r_nueva_region}`;
          }
        });
      });
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS REGIONALES
    agregar_regional(
      nueva_region,
      regional_existente,
      departamento,
      municipios
    ) {
      if (
        this.nueva_region != "" ||
        (this.regional_existente != "" &&
          this.municipio != "" &&
          this.municipios != "")
      ) {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        let agregar_efectos = db
          .collection("nuevo_regional")
          .get()
          .then((querySnapshot) => {
            let data = [];
            querySnapshot.forEach((doc) => data.push(doc.data()));
            data = data.map((regional) => regional.r_nueva_region);
            if (data.includes(regional_existente)) {
              let agregar_efectos1 = db
                .collection("nuevo_regional")
                .where("r_nueva_region", "==", regional_existente)
                .get()
                .then((querySnapshot) => {
                  let data1 = [];
                  querySnapshot.forEach((doc) => data1.push(doc.data()));
                  data1 = data1.map((efecto1) => efecto1.r_departamento);
                  if (data1.includes(departamento)) {
                    let consultar_if_efecto = db
                      .collection("nuevo_regional")
                      .where("r_nueva_region", "==", regional_existente)
                      .where("r_departamento", "==", departamento)
                      .get()
                      .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                          this.c_key_regional = `${doc.id}`;
                          this.c_municipios = doc.data().r_municipios;
                        });
                        let resultado1 = this.c_municipios.concat(municipios);
                        db.collection("nuevo_regional")
                          .doc(this.c_key_regional)
                          .update({
                            r_municipios: resultado1,
                            r_fecha_registro: this.fecha,
                            r_hora_registro: this.hora_actual,
                          });
                      });
                  } else {
                    let newRegionalRef = db.collection("nuevo_regional").doc();
                    let id = newRegionalRef.id;
                    db.collection("nuevo_regional").doc(id).set({
                      r_nueva_region: regional_existente,
                      r_departamento: departamento,
                      r_municipios: municipios,
                      r_fecha_registro: this.fecha,
                      r_hora_registro: this.hora_actual,
                      r_registrado_por: this.$store.state.email,
                    });
                  }
                });
            } else {
              let newRegionalRef = db.collection("nuevo_regional").doc();
              let id = newRegionalRef.id;
              db.collection("nuevo_regional").doc(id).set({
                r_nueva_region: nueva_region,
                r_departamento: departamento,
                r_municipios: municipios,
                r_fecha_registro: this.fecha,
                r_hora_registro: this.hora_actual,
                r_registrado_por: this.$store.state.email,
              });
            }
          });
        this.consultar_regionales_existentes();
        this.nueva_region = "";
        this.regional_existente = "";
        this.departamento = "";
        this.municipio = [];
      } else {
        alert("Llene todos los campos.");
      }
      NProgress.done();
      NProgress.remove();
      $("#agregarregional").modal("hide");
    },

    agregar_regional1(
      nueva_region,
      regional_existente,
      departamento,
      municipios
    ) {
      if (
        this.nueva_region != "" ||
        (this.regional_existente != "" &&
          this.municipio != "" &&
          this.municipios != "")
      ) {
        NProgress.start();
        var n = new Date();
        // AÑO
        var y = n.getFullYear();
        // MES
        var m = n.getMonth() + 1;
        // DÍA
        var d = n.getDate();
        // SE ORDENA A GUSTO
        this.fecha = d + "/" + m + "/" + y;

        // HORAS
        var horas = n.getHours();
        // MINUTOS
        var minutos = n.getMinutes();
        // SEGUNDOS
        var segundos = n.getSeconds();
        // VARIABLE QUE LO ALMACENA
        this.hora_actual = horas + ":" + minutos + ":" + segundos;

        let agregar_efectos = db
          .collection("nuevo_regional")
          .get()
          .then((querySnapshot) => {
            let data = [];
            querySnapshot.forEach((doc) => data.push(doc.data()));
            data = data.map((regional) => regional.r_nueva_region);
            if (data.includes(regional_existente)) {
              let agregar_efectos1 = db
                .collection("nuevo_regional")
                .where("r_nueva_region", "==", regional_existente)
                .get()
                .then((querySnapshot) => {
                  let data1 = [];
                  querySnapshot.forEach((doc) => data1.push(doc.data()));
                  data1 = data1.map((efecto1) => efecto1.r_departamento);
                  if (data1.includes(departamento)) {
                    let consultar_if_efecto = db
                      .collection("nuevo_regional")
                      .where("r_nueva_region", "==", regional_existente)
                      .where("r_departamento", "==", departamento)
                      .get()
                      .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                          this.c_key_regional = `${doc.id}`;
                          this.c_municipios = doc.data().r_municipios;
                        });
                        let resultado1 = this.c_municipios.concat(municipios);
                        db.collection("nuevo_regional")
                          .doc(this.c_key_regional)
                          .update({
                            r_municipios: resultado1,
                            r_fecha_registro: this.fecha,
                            r_hora_registro: this.hora_actual,
                          });
                      });
                  } else {
                    let newRegionalRef = db.collection("nuevo_regional").doc();
                    let id = newRegionalRef.id;
                    db.collection("nuevo_regional").doc(id).set({
                      r_nueva_region: regional_existente,
                      r_departamento: departamento,
                      r_municipios: municipios,
                      r_fecha_registro: this.fecha,
                      r_hora_registro: this.hora_actual,
                      r_registrado_por: this.$store.state.email,
                    });
                  }
                });
            } else {
              let newRegionalRef = db.collection("nuevo_regional").doc();
              let id = newRegionalRef.id;
              db.collection("nuevo_regional").doc(id).set({
                r_nueva_region: nueva_region,
                r_departamento: departamento,
                r_municipios: municipios,
                r_fecha_registro: this.fecha,
                r_hora_registro: this.hora_actual,
                r_registrado_por: this.$store.state.email,
              });
            }
          });
        this.consultar_regionales_existentes();
        this.departamento = "";
        this.municipio = [];
      } else {
        alert("Llene todos los campos.");
      }
      NProgress.done();
      NProgress.remove();
      $("#agregarregional").modal("hide");
    },

    // FUNCIÓN PARA MOSTRAR DATOS REGIONALES
    consultar_regional(id_region) {
      NProgress.start();
      let query1 = db.collection("nuevo_regional").doc(id_region);
      query1.get().then((doc) => {
        if (doc.exists) {
          this.con_key = doc.id;
          this.con_regional = doc.data().r_nueva_region;
          this.con_departamento = doc.data().r_departamento;
          this.con_municipios = doc.data().r_municipios;
          this.con_fecha = doc.data().r_fecha_registro;
          this.con_hora = doc.data().r_hora_registro;
        }
        this.departamentos();
        this.municipios();
      });
      NProgress.done();
      NProgress.remove();
      $("#editarregional").modal("show");
    },

    // VACIAR VARIABLES
    vaciar_variables() {
      $("#editarregional").modal("hide");
      this.con_key = "";
      this.con_regional = "";
      this.con_departamento = "";
      this.con_municipios = [];
    },

    // EDITAR LAS REGIONALES
    editar_regional() {
      NProgress.start();
      if (this.guardar_todos == true) {
        // FUNCIÓN PARA EDITAR
        db.collection("nuevo_regional")
          .doc(this.con_key)
          .set({
            r_nueva_region: this.con_regional,
            r_departamento: this.con_departamento,
            r_municipios: this.municipio_general1,
            r_fecha_registro: this.con_fecha,
            r_hora_registro: this.con_hora,
            r_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {});
      }
      if (this.guardar_todos == false) {
        db.collection("nuevo_regional")
          .doc(this.con_key)
          .set({
            r_nueva_region: this.con_regional,
            r_departamento: this.con_departamento,
            r_municipios: this.con_vacio,
            r_fecha_registro: this.con_fecha,
            r_hora_registro: this.con_hora,
            r_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {});
      }
      if (this.guardar_todos == "") {
        db.collection("nuevo_regional")
          .doc(this.con_key)
          .set({
            r_nueva_region: this.con_regional,
            r_departamento: this.con_departamento,
            r_municipios: this.con_municipios,
            r_fecha_registro: this.con_fecha,
            r_hora_registro: this.con_hora,
            r_registrado_por: this.$store.state.email,
          })
          .then(() => {})
          .catch((error) => {});
      }
      this.guardar_todos = "";
      this.con_regional = "";
      this.con_departamento = "";
      this.con_municipios = [];
      this.municipio_general1 = [];
      NProgress.done();
      NProgress.remove();
      $("#editarregional").modal("hide");
    },

    // SELECCIONAR TODOS LOS CHECKBOX
    seleccionarTodo() {
      $("#checkTodos").change(() => {
        $("input:checkbox").prop("checked", $(this).prop("checked"));
      });
      if (this.guardar_todos == false) {
        this.guardar_todos = true;
      } else if (this.guardar_todos == true) {
        this.guardar_todos = false;
      }
    },

    // ELIMINAR PROCESO
    eliminar_regional(key_efecto) {
      Swal.fire({
        title: "¿Seguro que desea eliminar este usuario?",
        text: "¡Una vez eliminado, no podrás volver a ver el usuario!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          db.collection("nuevo_regional")
            .doc(key_efecto)
            .delete()
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Regional eliminada satisfactoriamente.",
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            });
        }
      });
      this.consultar_regionales_existentes();
    },

    // DEPARTAMENTOS DE COLOMBIA
    departamentos() {
      let docRef = db
        .collection("departamentos_colombia")
        .orderBy("departamento", "asc");
      docRef.onSnapshot((querySnapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.array_departamento = [];
        querySnapshot.forEach((doc) => {
          this.array_departamento.push({
            key: doc.id,
            departamento: doc.data().departamento,
          });
        });
      });
    },

    // MUNICIPIOS COLOMBIA
    municipios_colombia() {
      this.municipio = [];
      let docRef = db
        .collection("departamentos_colombia")
        .where("departamento", "==", this.departamento)
        .orderBy("municipios", "asc");
      docRef.onSnapshot((querySnapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.municipio_general = [];
        querySnapshot.forEach((doc) => {
          this.municipio_general.push(...doc.data().municipios);
        });
      });
    },

    municipios() {
      let docRef = db
        .collection("departamentos_colombia")
        .where("departamento", "==", this.con_departamento)
        .orderBy("municipios", "asc");
      docRef.onSnapshot((querySnapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.municipio_general1 = [];
        querySnapshot.forEach((doc) => {
          this.municipio_general1.push(...doc.data().municipios);
        });
      });
    },

    municipios1() {
      this.con_municipios = "";
      let docRef = db
        .collection("departamentos_colombia")
        .where("departamento", "==", this.con_departamento)
        .orderBy("municipios", "asc");
      docRef.onSnapshot((querySnapshot) => {
        // LIMPIAR ARRAY ANTES DE CONSULTAR
        this.municipio_general1 = [];
        querySnapshot.forEach((doc) => {
          this.municipio_general1.push(...doc.data().municipios);
        });
      });
    },
  },
  computed: {
    selectAll: {
      get() {
        return this.municipio_general
          ? this.municipio.length == this.municipio_general.length
          : false;
      },
      set(value) {
        let municipio = [];
        if (value) {
          this.municipio_general.forEach((i) => {
            municipio.push(i);
          });
        }
        this.municipio = municipio;
      },
    },
  },
};
</script>